import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.pale,
  borderColor: colors.offWhite,
  linkColor: colors.dustyTeal
};
export default jumplink;